export default function getEnvironmentConfig() {
  const env = window.__ENV__ || {};
  return {
    environment: env.ENVIRONMENT || 'local',
  };
}
